import React from "react";
import './header.css'

const Header = () => {
    return (
        <div className='header'>
            <div className='logo'>
                Jerry Hou
            </div>
        </div>
    )
}

export default Header;